import React, {useState} from 'react';
import {Image} from "react-bootstrap"; // Optional for custom styling
import dashboardImage from "../../../assets/img/dashboard.webp";
import otherImage from "../../../assets/img/dkim-example-entry.webp";
import dmarcAdvantages from "../../../assets/img/dmarc-advantages.webp";
import {useTranslation} from "react-i18next";
import baseHostname from "../../../hostname"; // Optional for custom styling
import {useDispatch} from 'react-redux';
import {useNavigate} from "react-router-dom";
import {FeatureItem} from "../common/FeatureItem";


export const DKIMChecker = () => {
    const [domain, setDomain] = useState('');
    const [selector, setSelector] = useState('');
    const [result, setResult] = useState('');
    const [loading, setLoading] = useState(false);
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate(); // Hook for programmatic navigation

    const fetchDmarcRecord = async (e) => {
        e.preventDefault();
        setResult('');
        setLoading(true);

        fetch(
            baseHostname + '/index.php/domain/analyze',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(
                    {
                        source: "DKIM",
                        domain: domain,
                        selector: selector
                    }
                )
            }
        )
            .then(response => {
                if (!response.ok) {
                    console.warn('Server returned an error:', response.status);
                    return null;
                }
                return response.json();
            })
            .then(data => {
                if (data) {
                    // Save the DMARC validation result into Redux
                    dispatch({type: 'SET_DKIM_ANALYZE_RESULT', payload: data});
                    // Redirect to the results page
                    navigate('/dkim/result');
                }
            })
            .catch(error => {
                console.error('Error during API call:', error);
            });

    };

    const getCardIcon = (num) => {
        const icons = {
            "one": "bi bi-tv-fill text-primary",
            "two": "bi bi-window-fullscreen text-primary",
            "three": "bi bi-unlock-fill text-primary",
            "four": "bi bi-globe-americas text-primary",
            "five": "bi bi-stars text-primary",
            "six": "bi bi-shield-check text-primary",
        };
        return icons[num] || "bi bi-box text-primary";
    };


    return (
        <div className="container-fluid">
            <div className={"row pt-5"} style={{backgroundColor: "#F5F7FF"}}>
                <div className="col-12">
                    <header className="mb-5 text-center px-3">
                        <h1>{t("pages.dkimChecker.lookup.title")}</h1>
                        <p className="lead">{t("pages.dkimChecker.lookup.subTitle")}</p>
                    </header>
                </div>
            </div>
            <div className={"row d-flex justify-content-center pb-5"} style={{backgroundColor: "#F5F7FF"}}>
                <div className="col-12 col-md-10 col-lg-8 px-4 px-md-2">
                    <form onSubmit={fetchDmarcRecord}
                          className="mb-4 bg-white p-4 p-md-5 rounded rounded-3 shadow d-flex flex-column">
                        <label htmlFor="domain">{t("pages.dkimChecker.lookup.form.title")}</label>
                        <input
                            id="domain"
                            className="form-control my-2"
                            placeholder="e.g. example.com"
                            value={domain}
                            onChange={(e) => setDomain(e.target.value)}
                            required
                        />
                        <input
                            id="domain"
                            className="form-control form-control-sm my-2"
                            placeholder="e.g. dkim"
                            value={selector}
                            onChange={(e) => setSelector(e.target.value)}
                        />
                        <button className="btn btn-primary text-white align-self-end mt-3" type="submit"
                                disabled={loading}>
                            {loading ? t("pages.dkimChecker.lookup.form.checking") : t("pages.dkimChecker.lookup.form.check")}
                        </button>
                    </form>
                    {result && (
                        <div className="alert alert-info">
                            <strong>Result:</strong>
                            <pre className="mb-0">{result}</pre>
                        </div>
                    )}
                </div>
            </div>
            <div className={"row d-flex justify-content-center pt-5 pb-5"} style={{backgroundColor: "#FEFEFF"}}>
                <div className="col-12 col-md-10 col-lg-5 p-4 p-lg-5">
                    <h4>{t("pages.dkimChecker.dashboard.title")} </h4>
                    <div className={"container-fluid p-0"}>
                        <div className={"row"}>
                            <div className={"col"}>
                                <p> {t("pages.dkimChecker.dashboard.body1")}</p>
                            </div>
                        </div>
                        <div className={"row"}>
                            <div className={"col"}>
                                <p> {t("pages.dkimChecker.dashboard.body2")}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 col-md-10 col-lg-5 d-flex align-items-center justify-content-center px-4">
                    <Image src={dashboardImage} alt={"dashboard"} className={"img-fluid rounded rounded-1"}></Image>
                </div>
            </div>
            <div className={"row d-flex flex-column justify-content-center pt-5 pb-5 align-items-center"}
                 style={{backgroundColor: "#F4F7FF"}}>
                <div className="col-12 col-md-10 col-lg-5 p-4 p-lg-5">
                    <h4>{t("pages.dkimChecker.whatIsDkim.title1")}</h4>
                    <p> {t("pages.dkimChecker.whatIsDkim.body1")}
                    </p>
                </div>
                <div
                    className="col-12 col-md-10 col-lg-5 d-flex align-items-center justify-content-center px-4 mb-4 mb-lg-0">
                    <Image src={otherImage} alt={"dashboard"}
                           className={"img-fluid rounded shadow"}></Image>
                </div>
                <div className="col-12 col-md-10 col-lg-5 p-4 p-lg-5">
                    <h4>{t("pages.dkimChecker.whatIsDkim.title2")}</h4>
                    <p> {t("pages.dkimChecker.whatIsDkim.body2")}
                    </p>
                </div>
            </div>
            <div className={"row d-flex justify-content-center pt-5 pb-5"} style={{backgroundColor: "#FEFEFF"}}>
                <div
                    className="col-12 col-md-10 col-lg-5 d-flex align-items-center justify-content-center px-4 mb-4 mb-lg-0">
                    <Image src={dmarcAdvantages} alt={"dashboard"} className={"img-fluid"}></Image>
                </div>
                <div className="col-12 col-md-10 col-lg-5 p-4 p-lg-5">
                    <h4>{t("pages.dkimChecker.howDoesDkimWork.title")}</h4>
                    <p> {t("pages.dkimChecker.howDoesDkimWork.body")}
                    </p>
                </div>
            </div>
            <div className={"row justify-content-center pt-5 pb-5"} style={{backgroundColor: "#F4F7FF"}}>
                <div className="col-12 col-md-10 col-lg-5 p-4 p-lg-5">
                    <h4>{t("pages.dkimChecker.whatIsDkimRecordCheck.title1")}</h4>
                    <p> {t("pages.dkimChecker.whatIsDkimRecordCheck.body1")}
                    </p>
                </div>
                <div className="col-12 col-md-10 col-lg-5 p-4 p-lg-5">
                    <h4>{t("pages.dkimChecker.whatIsDkimRecordCheck.title2")}</h4>
                    <p> {t("pages.dkimChecker.whatIsDkimRecordCheck.body2")}
                    </p>
                </div>
            </div>

            {/* Section Header */}
            <div className="row justify-content-center pt-5" style={{backgroundColor: "#FEFEFF"}}>
                <div className="col-12 col-md-10 col-lg-8 px-4 text-center">
                    <h4 className="text-primary">{t("pages.dkimChecker.secureServers.features.title")}</h4>
                    <p className="small">{t("pages.dkimChecker.secureServers.features.subTitle")}</p>
                </div>
            </div>

            {/* Feature List */}
            <div className="row justify-content-center pb-5" style={{backgroundColor: "#FEFEFF"}}>
                <div className="col-12 col-md-10 col-lg-8 px-4 d-flex flex-column align-items-center text-center">
                    <FeatureItem
                        title={t("pages.dkimChecker.secureServers.features.list.one.title")}
                        description={t("pages.dkimChecker.secureServers.features.list.one.description")}
                        iconClass="bi bi-inboxes-fill text-primary"
                    />
                    <FeatureItem
                        title={t("pages.dkimChecker.secureServers.features.list.two.title")}
                        description={t("pages.dkimChecker.secureServers.features.list.two.description")}
                        iconClass="bi bi-shield-x text-primary"
                    />
                    <FeatureItem
                        title={t("pages.dkimChecker.secureServers.features.list.three.title")}
                        description={t("pages.dkimChecker.secureServers.features.list.three.description")}
                        iconClass="bi bi-hdd-stack-fill text-primary"
                    />
                    <FeatureItem
                        title={t("pages.dkimChecker.secureServers.features.list.four.title")}
                        description={t("pages.dkimChecker.secureServers.features.list.four.description")}
                        iconClass="bi bi-globe-asia-australia text-primary"
                    />
                    <FeatureItem
                        title={t("pages.dkimChecker.secureServers.features.list.five.title")}
                        description={t("pages.dkimChecker.secureServers.features.list.five.description")}
                        iconClass="bi bi-ethernet text-primary"
                    />
                </div>
            </div>


            {/* FAQ Section */}
            <div className="row justify-content-center pt-5 pb-5 text-center" style={{backgroundColor: "#F4F7FF"}}>
                <div className="col-12 col-md-10 col-lg-6 px-4">
                    <h3>{t("pages.dkimChecker.dkimFaq.title")}</h3>
                    <span className="d-block mb-4">{t("pages.dkimChecker.dkimFaq.subTitle")}</span>

                    <div className="accordion mt-4 text-start" id="faqAccordion">
                        {/* FAQ Item 1 */}
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingOne">
                                <button
                                    className="accordion-button"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseOne"
                                    aria-expanded="true"
                                    aria-controls="collapseOne"
                                >
                                    {t("pages.dkimChecker.dkimFaq.list.one.question")}
                                </button>
                            </h2>
                            <div
                                id="collapseOne"
                                className="accordion-collapse collapse show"
                                aria-labelledby="headingOne"
                                data-bs-parent="#faqAccordion"
                            >
                                <div
                                    className="accordion-body"
                                    dangerouslySetInnerHTML={{
                                        __html: t("pages.dkimChecker.dkimFaq.list.one.answer"),
                                    }}
                                />
                            </div>
                        </div>

                        {/* FAQ Item 2 */}
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingTwo">
                                <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo"
                                    aria-expanded="false"
                                    aria-controls="collapseTwo"
                                >
                                    {t("pages.dkimChecker.dkimFaq.list.two.question")}
                                </button>
                            </h2>
                            <div
                                id="collapseTwo"
                                className="accordion-collapse collapse"
                                aria-labelledby="headingTwo"
                                data-bs-parent="#faqAccordion"
                            >
                                <div className="accordion-body">
                                    {t("pages.dkimChecker.dkimFaq.list.two.answer")}
                                </div>
                            </div>
                        </div>
                        {/* FAQ Item 3 */}
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingTwo">
                                <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo"
                                    aria-expanded="false"
                                    aria-controls="collapseTwo"
                                >
                                    {t("pages.dkimChecker.dkimFaq.list.three.question")}
                                </button>
                            </h2>
                            <div
                                id="collapseTwo"
                                className="accordion-collapse collapse"
                                aria-labelledby="headingTwo"
                                data-bs-parent="#faqAccordion"
                            >
                                <div className="accordion-body">
                                    {t("pages.dkimChecker.dkimFaq.list.three.answer")}
                                </div>
                            </div>
                        </div>
                        {/* FAQ Item 4 */}
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingTwo">
                                <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo"
                                    aria-expanded="false"
                                    aria-controls="collapseTwo"
                                >
                                    {t("pages.dkimChecker.dkimFaq.list.four.question")}
                                </button>
                            </h2>
                            <div
                                id="collapseTwo"
                                className="accordion-collapse collapse"
                                aria-labelledby="headingTwo"
                                data-bs-parent="#faqAccordion"
                            >
                                <div className="accordion-body">
                                    {t("pages.dkimChecker.dkimFaq.list.four.answer")}
                                </div>
                            </div>
                        </div>
                        {/* FAQ Item 5 */}
                        <div className="accordion-item">
                            <h2 className="accordion-header" id="headingTwo">
                                <button
                                    className="accordion-button collapsed"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#collapseTwo"
                                    aria-expanded="false"
                                    aria-controls="collapseTwo"
                                >
                                    {t("pages.dkimChecker.dkimFaq.list.five.question")}
                                </button>
                            </h2>
                            <div
                                id="collapseTwo"
                                className="accordion-collapse collapse"
                                aria-labelledby="headingTwo"
                                data-bs-parent="#faqAccordion"
                            >
                                <div className="accordion-body">
                                    {t("pages.dkimChecker.dkimFaq.list.five.answer")}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
};
